import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import '../../assets/scss/pages/authentication.scss'
import { IMAGE } from '../../configs/app-configs'
import CreatePassword from './CreatePassword'
import { useHistory } from 'react-router-dom'
import CompleteInformation from './CompleteInformation'
import LandingHeader from './LandingHeader'
import LandingFooter from './LandingFooter'

const LandingPage2 = (props) => {
  const [activeTab, setActiveTab] = useState('')
  const history = useHistory()

  useEffect(() => {
    setActiveTab(props.activeTab || 'create-password')
  }, [props.activeTab])

  const TabView = () => {
    switch (activeTab) {
      case 'create-password':
        return (
          <div className='col-12 col-md-10 cpl-lg-8 mx-auto'>
            <CreatePassword isLanding2/>
          </div>
        )
      case 'complete-information':
        return <CompleteInformation isLanding2 />
      default:
        return ''
    }
  }

  return (
    <React.Fragment>
      <div
        className='landing-page'
        style={{
          backgroundImage: `url('${IMAGE.LANDING_PAGE_2_BG}')`
        }}
      >
        <div className='col-10 mx-auto mb-5'>
          <div className='ld-main2'>
            <div className='ld-header d-flex justify-content-between  mb-5'>
              <LandingHeader isLanding2 />
            </div>
            <div
              className={classnames(
                'lg-content p-2 p-md-4 p-lg-5 col-12 mx-auto',
                {
                  'col-lg-6 col-md-8': activeTab !== 'complete-information'
                }
              )}
            >
              <TabView />
            </div>
          </div>
        </div>
        <LandingFooter />
      </div>
    </React.Fragment>
  )
}

export default LandingPage2
